import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/sections/legal-page'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import LegalPage from '@/components/sections/legal-page'

import { CONTACT } from '@/constants/site'

const SECTIONS: LegalSection[] = [
    {
        heading: "Using this website",
        paragraphs: [
            "By using this website you agree to these terms. If you do not agree with them, please do not use the site.",
            "This website is provided to share information about BLITZ and our services. You may browse and share its pages for personal and business purposes, but you may not misuse the site, interfere with how it works or attempt to access it in unauthorized ways."
        ]
    },
    {
        heading: "Intellectual property",
        paragraphs: [
            "Unless stated otherwise, the text, design, graphics and brand assets on this website belong to BLITZ or are used with permission. You may not copy, reproduce or reuse them for commercial purposes without our written consent.",
            "Photography and client trademarks remain the property of their respective owners."
        ]
    },
    {
        heading: "Concept projects and illustrative figures",
        paragraphs: [
            "Some projects on this website are marked as concept projects. They are speculative work created to show our approach and do not represent real client engagements or results.",
            "Figures marked as illustrative are placeholders and should not be relied on as verified performance data."
        ]
    },
    {
        heading: "No professional advice",
        paragraphs: [
            "Articles and insights on this website are general information. They are not tailored advice for your business, and you should seek specific guidance before making decisions based on them."
        ]
    },
    {
        heading: "Links to other websites",
        paragraphs: [
            "This website may link to websites run by other organizations. We are not responsible for their content or their privacy practices."
        ]
    },
    {
        heading: "Limitation of liability",
        paragraphs: [
            "We work to keep this website accurate and available, but we provide it as is and cannot guarantee that it will always be complete, current or free of errors. To the extent permitted by law, BLITZ is not liable for any loss arising from your use of the website."
        ]
    },
    {
        heading: "Changes to these terms",
        paragraphs: [
            "We may update these terms from time to time. The date at the top of this page shows when they were last changed."
        ]
    },
    {
        heading: "Contact",
        paragraphs: [
            CONTACT.email
                ? `Questions about these terms can be sent to ${CONTACT.email} or through the contact form on this website.`
                : "Questions about these terms can be sent through the contact form on this website."
        ]
    }
]

const TermsPage: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='Terms and conditions' description='The terms that apply when you use the BLITZ website.' />
            <LegalPage label='Legal' title='Terms and conditions' updated='October 16, 2026' sections={SECTIONS} />
        </Layout>
    )
}

export default TermsPage
